import { PortableTextBlockComponent } from '@portabletext/react'
import { getAdvertorialAttributeByCard } from '../../../utils'
import { CompareCredit } from '../../../../types'

export const Normal: PortableTextBlockComponent = ({
  children,
}: React.PropsWithChildren) => <p>{children}</p>

export const AttributeRenderer = (
  referencedCards: null | Record<string, CompareCredit.Entity>,
) => {
  const render: React.FC<{
    value: { attribute: string; bonusRewards: string; cards: { _ref: string } }
  }> = ({ value: { attribute, bonusRewards, cards } }) => {
    if (!referencedCards) {
      return <></>
    }
    const card = Object.values(referencedCards).find(
      (referencedCard) => referencedCard._id === cards._ref,
    ) as CompareCredit.FormattedCard
    return getAdvertorialAttributeByCard({
      card,
      attribute,
      bonusRewards,
    })
  }
  return render
}
